import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import theme from "../../../theme";

function AboutUsWelcomeComponent() {
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Box
      sx={{
        width: "100%",
        marginTop: "30px",
        display: "flex",
        flexDirection: "column",
        gap: isMobile ? "28px" : "40px",
        height: "auto",
        marginBottom: "90px",
        padding: isMobile ? "22px 16px" : "40px 36px",
        background:
          "linear-gradient(180deg, rgba(255,249,238,1) 0%, rgba(255,255,255,1) 55%, rgba(246,247,249,1) 100%)",
        borderRadius: "24px",
        border: "1px solid rgba(20, 20, 20, 0.08)",
      }}
    >
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "1.1fr 0.9fr",
          gap: isMobile ? "22px" : "32px",
        }}
      >
        <Box
          sx={{
            padding: isMobile ? "16px" : "24px",
            borderRadius: "18px",
            backgroundColor: "#FFFFFF",
            boxShadow: "0 16px 40px rgba(15, 15, 15, 0.08)",
          }}
        >
          <Typography
            variant="overline"
            sx={{
              color: theme.palette.primary.main,
              fontWeight: 700,
              letterSpacing: "0.08em",
            }}
          >
            About Us
          </Typography>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              fontSize: isMobile ? "22px" : "30px",
              marginBottom: "14px",
              fontFamily: "'Playfair Display', 'Times New Roman', serif",
            }}
          >
            MasterBladeMM
          </Typography>
          <Typography
            variant="body1"
            sx={{
              fontSize: isMobile ? "13px" : "16px",
              lineHeight: 2,
              textAlign: "justify",
              color: theme.palette.text.secondary,
            }}
          >
            MasterBladeMM သည် လုံခြုံရေးသုံး ဘလိတ်ဓါးဆူးကြိုးများကို
            ပစ္စည်းမှန်၊ဈေးနှုန်းမှန်ဖြင့် မြန်မာနိုင်ငံအဝှမ်း စီးပွားရေးလုပ်ငန်းများနှင့်
            အိမ်ရှင်များထံ ပေးအပ်လျက်ရှိပါသည်။လုံခြုံရေးလိုအပ်ချက်အမျိုးမျိုးကို
            တိကျစွာ ဖြည့်ဆည်းနိုင်ရန် အရည်အသွေးမြင့် ပစ္စည်းများနှင့်
            ယုံကြည်ရသော ဝန်ဆောင်မှုကို အခြေခံထားပါသည်။
          </Typography>
          <Box sx={{ height: "12px" }} />
          <Typography
            variant="body1"
            sx={{
              fontSize: isMobile ? "13px" : "16px",
              lineHeight: 2,
              textAlign: "justify",
              color: theme.palette.text.secondary,
            }}
          >
            လုံခြုံရေးတပ်ဆင်ခြင်းလုပ်ငန်းတွင်လိုအပ်သည့်အမျိုးအစားမျိုးစုံသော
            ဘလိတ်ဓါးဆူးကြိုးများ၊ ဆက်စပ်ပစ္စည်းများကို စနစ်တကျ ထောက်ပံ့ပေးပြီး
            တပ်ဆင်ရေးလုပ်ငန်းကိုလည်း ကျွမ်းကျင်ဝန်ထမ်းများဖြင့်
            အကောင်းဆုံး အောင်မြင်စွာ ဆောင်ရွက်ပေးပါသည်။
          </Typography>
          <Box sx={{ height: "12px" }} />
          <Typography
            variant="body1"
            sx={{
              fontSize: isMobile ? "13px" : "16px",
              lineHeight: 2,
              textAlign: "justify",
              color: theme.palette.text.secondary,
            }}
          >
            အရည်အသွေး၊ ယုံကြည်မှုနှင့် လုံခြုံရေးကို ဦးစားပေးကာ
            မြို့အနှံ့ အိမ်ခြံမြေ၊ စက်ရုံ၊ ဂိုဒေါင်များအတွက်
            စိတ်ချရသော ကာကွယ်ရေးဖြေရှင်းချက်များကို
            ပံ့ပိုးပေးရန် ရည်ရွယ်ထားပါသည်။
          </Typography>
        </Box>

        <Box sx={{ display: "grid", gap: "18px" }}>
          <Box
            sx={{
              padding: isMobile ? "16px" : "20px",
              borderRadius: "18px",
              backgroundColor: "#111827",
              color: "#F9FAFB",
            }}
          >
            <Typography
              variant="overline"
              sx={{ color: "#FBBF24", fontWeight: 700, letterSpacing: "0.08em" }}
            >
              Profile
            </Typography>
            <Typography
              variant="h5"
              sx={{
                fontWeight: 700,
                fontSize: isMobile ? "18px" : "22px",
                marginTop: "6px",
                marginBottom: "10px",
                fontFamily: "'Playfair Display', 'Times New Roman', serif",
              }}
            >
              Our Vision
            </Typography>
            <Typography
              variant="body1"
              sx={{ fontSize: isMobile ? "13px" : "14px", lineHeight: 1.9 }}
            >
              မြန်မာနိုင်ငံအဝှမ်းမည်သည့်မြို့တွင်မဆိုလုံခြုံရေးဘလိတ်ဓါးဆူးကြိုးများကိုအိမ်ရှင်တိုင်းအတွက်ပစ္စည်းမှန်၊ဈေးနှုန်းမှန်ဖြင့်အကောင်းဆုံးဝန်ဆောင်မှုပေးနိုင်ရန်။
            </Typography>
          </Box>

          <Box
            sx={{
              padding: isMobile ? "16px" : "20px",
              borderRadius: "18px",
              backgroundColor: "#FFFFFF",
              border: "1px solid rgba(17, 24, 39, 0.08)",
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 700,
                fontSize: isMobile ? "15px" : "16px",
                marginBottom: "6px",
              }}
            >
              Our Mission
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: isMobile ? "13px" : "14px",
                lineHeight: 1.9,
                color: theme.palette.text.secondary,
              }}
            >
              ၁.လုံခြုံရေးနှင့်ပတ်သတ်လာလျှင် အကောင်းဆုံးဝန်ဆောင်မူပေးနိုင်ရန်။<br />
              ၂.မသမာသူများ ၊ သူခိုးသူဝှက်များ၏ ရန်မူ ၊ ခိုးဝှက်မှူများ ကိုတစ်ဖက်တစ်လမ်း အထိရောက်ဆုံးကာကွယ်နိုင်ရန် ။<br />
              ၃.လုံခြုံရေးနှင့် ပတ်သတ်လာလျှင် အိမ်ရှင်တိုင်း ဘလိတ်ဓါးဆူးကြိုးတပ်ဆင်နိုင်ရန် ရည်ရွယ်ပါသည်။
            </Typography>
          </Box>

          <Box
            sx={{
              padding: isMobile ? "16px" : "20px",
              borderRadius: "18px",
              backgroundColor: "#FFFFFF",
              border: "1px solid rgba(17, 24, 39, 0.08)",
            }}
          >
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 700,
                fontSize: isMobile ? "15px" : "16px",
                marginBottom: "6px",
              }}
            >
              Why Choose Us
            </Typography>
            <Box
              component="ul"
              sx={{
                margin: 0,
                paddingLeft: isMobile ? "18px" : "22px",
                display: "grid",
                gap: "8px",
                color: theme.palette.text.secondary,
                fontSize: isMobile ? "13px" : "14px",
                lineHeight: 1.8,
              }}
            >
              <Box component="li">
                Item Quality အမျိုးမျိုးကို သင့်တင့်မျှတသော ဈေးနူန်းများဖြင့်
                လူကြီးမင်းများ စိတ်တိုင်းကျ ရွေးချယ်ဝယ်ယူတပ်ဆင်နိုင်ပါသည်။
              </Box>
              <Box component="li">
                တပ်ဆင်ရာတွင် အသုံးပြုသော ကုန်ကြမ်းများဖြစ်တဲ့ ဟင်ဂလန်
                steel ချည်ကြိုး ၊ Steel တန်းကြိုး ၊ ကြံဆစ်ပန်းလုံးများကို
                မခိုးမကပ်ဘဲ လိုသလောက် အသုံးပြုတပ်ဆင်ပေးပါသည်။
              </Box>
              <Box component="li">
                မီးမရသည့် နေရာများအတွက်လည်း ကိုယ်ပိုင်မီးစက်ဖြင့်
                လာရောက်တပ်ဆင်ပေးပါသည်။
              </Box>
              <Box component="li">
                ဖုန်းလေးတစ်ချက်ဆက်လိုက်ရုံဖြင့် လူကြီးမင်းတို့၏
                အိမ်တိုင်ရာရောက် မြေပြင်ကွင်းဆင်းပြီး အသေးစိတ်ကို
                အခမဲ့ ဆွေးနွေးပေးပါသည်။
              </Box>
              <Box component="li">
                Survey ဆင်းသည်မှ စ၍အပြီးစီးတပ်ဆင်ကာရံပြီးစီးသည်အထိ
                လူကြီးမင်းများ စိတိတိုင်းကျသည်အထိ ကျွမ်းကျင်ဝန်ထမ်းများ ၊
                တပ်ဆင်ရေးပညာရှင်များဖြင့် အကောင်းဆုံးဝန်‌ဆောင်မူပေးလျက်ရှိပါသည်။
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>

  )
}

export default AboutUsWelcomeComponent
